$(document).ready(function() {
  /*Selected option val */
  var variantPrice = $('.selected-options').find(":selected").attr("price-attrs");

  if (variantPrice > 5500) {
    $(".product-blcok-iconText").show();
  } else {
    $(".product-blcok-iconText").hide();
  }
  /*end code */

  /* Subscription options*/
    var sellingPlanValue = $('input[name="selling_plan"]').val();
    var sellingdiscountValue = $('input[name="properties[Discount]"]').val();

    $(".selling-plan").val(sellingPlanValue);
    $(".discount-value").val(sellingdiscountValue);
  /*end of subscription options*/

  var selected_radio = $("input.activeOption:checked").val();
  $('.subscription input[value="' + selected_radio + '"]').attr('checked', 'checked');

  if(selected_radio == '500g') {
    $('input[name="selling_plan"]').val('')
  }

  var btn = $(".product-block-buy-buttons").html();
  $(".pdp-btns").html(btn);

  $(".selected-variant-options select.selected-options").on("change", function() {
    var find_closest = $(this).closest(".sticky-pdp-form").find(".btn-part-sticky");
    var selected_price = $(this).children("option:selected").attr("data-price");
    var selected_val = $(this).children("option:selected").attr("data-val");
    var selected_discount = $(this).children("option:selected").attr("data-discount");
    var selected_ids = $(this).children("option:selected").val();

    if (selected_discount) {
      setTimeout(function() {
        $(".discount-price").addClass("has-discount");
        $(".discount-price").text("-" + selected_discount);
      }, 200);
    } else {
      setTimeout(function() {
        $(".discount-price").removeClass("has-discount");
        $(".discount-price").text("");
      }, 200);
    }

    $(this).parent().find("select option:selected").each(function() {
      var optionVal = $(this).val();
      $('.product-subscriptions input[data-id="' + optionVal + '"]').attr('checked', 'checked');
      $('.product-subscriptions input[data-id="' + optionVal + '"]').trigger("click");
      var variantPrice = $('.selected-options').find(":selected").attr("price-attrs");

      if (variantPrice > 5500) {
        $(".product-blcok-iconText").show();
      } else {
        $(".product-blcok-iconText").hide();
      }
    });

    var target_div = find_closest.find(".pdp-variant-price");
    $(".new-form-options").removeClass("selectedWB");
    target_div.html(selected_price);
    var titles_option = $.trim(selected_val);
    var vals = $(this).children("option:selected").val();
    $(".option-trigger-" + titles_option).trigger("click");
    $("#id" + selected_ids).trigger("click");
    $("#id" + selected_ids).addClass("selectedWB");
    var selected_optins = $(this).children("option:selected").text();
    var variantPrice = $(this).children("option:selected").attr("price-attrs");
    if (variantPrice > 5500) {
      $(".product-blcok-iconText").show();
    } else {
      $(".product-blcok-iconText").hide();
    }
  });

  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 104) {
      $("body").addClass("stickyatc");
    } else {
      $("body").removeClass("stickyatc");
    }
  });

  $(".variant-input :radio").on("change", function() {
    var find_closest = $(this).closest(".product-block-variant-picker").closest(".product-temp-blocks");
    var find_form = find_closest.find(".product-block-buy-buttons");
    var sellingPlanValue = $('input[name="selling_plan"]').val();
    var sellingdiscountValue = $('input[name="properties[Discount]"]').val();

    $(".selling-plan").val(sellingPlanValue);
    $(".discount-value").val(sellingdiscountValue);

    var target_div = find_closest.find(".pdp-variant-price");
    var data_handle = $(this).attr("data-handle");

    $(".variant-input input").removeClass("activeOption");
    $(this).addClass("activeOption");
    $('.selected-options option[data-val="' + data_handle + '"]').prop("selected", true);
    var selectdPrice = $('.selected-options :selected').attr("data-price");
    var selected_discount = $('.selected-options :selected').attr("data-discount");
    if (selected_discount) {
      setTimeout(function() {
        $(".discount-price").addClass("has-discount");
        $(".discount-price").text("- " + selected_discount);
      }, 200);
    } else {
      setTimeout(function() {
        $(".discount-price").removeClass("has-discount");
        $(".discount-price").text("");
      }, 200);
    }
    $(".sticky-product-items .pdp-variant-price").html(selectdPrice);
    $('.subscription input[data-attr="' + data_handle + '"]').attr('checked', 'checked');
    var variantPrice = $('.selected-options').find(":selected").attr("price-attrs");

    if (variantPrice > 5500) {
      $(".product-blcok-iconText").show();
      console.log("variant is greater than 33", "radios");
    } else {
      $(".product-blcok-iconText").hide();
      console.log("variant is less than 33", "radios");
    }
    var sellingPlanInput = $('input[name="selling_plan"]');
    var discountInput = $('input[name="properties[Discount]"]')
    if($(this).val() == '500g') {
      // $('input[name="selling_plan"]').val('')
      // $('input[name="properties[Discount]"]').val('');
      setTimeout(function() {
        clearInputRecursively(sellingPlanInput)
        clearInputRecursively(discountInput)
      }, 100);
    } 

 
  });
  function clearInputRecursively(inputElement) {
    if (inputElement.val() !== '') {
        inputElement.val(''); // Clear the value of the input field
        clearInputRecursively(inputElement); // Recursively call the function
    }
  }
});
